'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirlineSeatLegroomReduced = function MdAirlineSeatLegroomReduced(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.4 20q0 2 1.4 3.5t3.6 1.5h6.6v3.4h-6.6q-3.5 0-5.9-2.5t-2.5-5.9v-15h3.4v15z m24.9 12q0.2 1.2-0.5 2.1t-1.9 0.9h-7.5v-5l1.6-6.6h-10q-2 0-3.5-1.5t-1.5-3.5v-13.4h10v10h8.4q1.3 0 2.3 1t0.9 2.4l-3.2 11.6h2.3q0.9 0 1.7 0.6t0.9 1.4z' })
        )
    );
};

exports.default = MdAirlineSeatLegroomReduced;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airline-seat-legroom-reduced.js
// module id = 3044
// module chunks = 168707334958949